import React from 'react';
import {
    Box,
    Grid,
    Tooltip,
    Typography
} from '@mui/material';

import { RequirementsMatchType } from '../../types/RequirementsType';
import { SectionDivider } from '../CommonComponents';

type PropsType = {
    label: string;
    entityMetadata: string[];
    requirementsMatches?: RequirementsMatchType[];
    icon: React.ReactNode;
    isMyJob: boolean;
};

export default function RequirementsSection(props: PropsType) {
    const {
        label,
        entityMetadata,
        requirementsMatches,
        icon,
        isMyJob
    } = props;

    return (
        <Grid item xs={6} px={2}>
            <SectionDivider
                label={`${label} (${entityMetadata.length})`}
                color="inherit"
                marginBottom={1}
                marginTop={0}
            />
            <Box
                sx={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    justifyContent: 'flex-content-start',
                    columnGap: 2,
                    rowGap: 1,
                    pl: '25px'
                }}
            >
                {!isMyJob && requirementsMatches && (
                    requirementsMatches
                        .sort((a, b) => {
                            if (a.has === b.has) return 0;
                            return a.has ? -1 : 1;
                        })
                        .map((req) => (
                            <Tooltip title={req.has
                                ? 'Du uppfyller kravet'
                                : 'Du uppfyller inte kravet, om detta inte stämmer - uppdatera din företagsprofil'}
                            >
                                <Box sx={{ display: 'inline-flex', alignItems: 'auto', minWidth: 0 }}>
                                    {icon && React.cloneElement(icon as React.ReactElement, {
                                        fontSize: 'small',
                                        sx: { verticalAlign: 'middle', color: req.has ? 'success.main' : 'error.main' }
                                    })}
                                    <Typography
                                        variant="body2"
                                        component="span"
                                        sx={{ ml: 0.5, color: 'inherit', fontWeight: 300 }}
                                    >

                                        {req.name}
                                    </Typography>
                                </Box>
                            </Tooltip>
                        ))
                )}
                {isMyJob && (
                    entityMetadata.map((req) => (
                        <Box sx={{ display: 'inline-flex', alignItems: 'auto', minWidth: 0 }}>
                            {icon}
                            <Typography
                                variant="body2"
                                component="span"
                                sx={{ ml: 0.5, color: 'inherit', fontWeight: 300 }}
                            >
                                {req}
                            </Typography>
                        </Box>
                    ))
                )}
            </Box>
        </Grid>
    );
}
